export default {
  getRiskStatus: function (score) {
    const normalizedScore = !score ? 1 : Math.min(score, 7);
    const riskStatusMap = [
      { threshold: 2, status: 'Sécuritaire' },
      { threshold: 3, status: 'Défensif' },
      { threshold: 5, status: 'Équilibré' },
      { threshold: 7, status: 'Dynamique' },
    ];

    const matchedStatus = riskStatusMap.find(entry => {
      return normalizedScore <= entry.threshold;
    });

    return matchedStatus.status;
  },

  getRiskDescription: function (score): string {
    const normalizedScore = !score ? 1 : Math.min(score, 7);
    const riskDescriptions = [
      {
        threshold: 2,
        description:
          'Un profil de risque sécuritaire est généralement considéré comme étant le moins risqué. Il est souvent recommandé aux personnes âgées ou aux personnes ayant des antécédents de santé préoccupants. Ce type de profil de risque vise à minimiser les risques et à garantir un niveau de protection élevé.',
      },
      {
        threshold: 3,
        description:
          'Un profil de risque défensif est considéré comme étant un peu plus risqué que le profil de risque sécuritaire, mais reste tout de même relativement sûr. Il est souvent recommandé aux personnes ayant une santé relativement bonne et une tolérance au risque modérée.',
      },
      {
        threshold: 5,
        description:
          'Un profil de risque équilibré est considéré comme étant à la fois sûr et rentable. Il vise à trouver un équilibre entre le niveau de protection et le potentiel de rendement financier. Ce type de profil de risque est souvent recommandé aux personnes ayant une tolérance au risque modérée à élevée.',
      },
      {
        threshold: 7,
        description:
          'Un profil de risque dynamique est considéré comme étant plus risqué que les profils de risque précédents, mais offre également un potentiel de rendement financier plus élevé. Il est souvent recommandé aux personnes ayant une tolérance au risque élevée et une horizon de placement à long terme.',
      },
    ];

    const matchedDescription = riskDescriptions.find(entry => {
      return normalizedScore <= entry.threshold;
    });

    return matchedDescription.description;
  },
};
